<template>
  <div class="mh-style-picker">
    <div class="mh-style-picker__header">
      <i class="fa fa-image mh-style-picker__header-icon" />
      <span><b>{{ header }}</b> · pick a style</span>
    </div>
    <div class="mh-style-picker__cards">
      <button
        v-for="card in cards"
        :key="card.key"
        type="button"
        class="mh-style-picker__card"
        :class="{ 'is-selected': selectedAction === card.action }"
        :disabled="disabled || !!selectedAction"
        @click="$emit('action', card.action)"
      >
        <img
          :src="card.thumbnail"
          :alt="card.title"
          class="mh-style-picker__card-thumb"
        >
        <div class="mh-style-picker__card-title">
          {{ card.title }}
        </div>
        <div class="mh-style-picker__card-subtitle">
          {{ card.subtitle }}
        </div>
      </button>
    </div>
    <button
      v-if="skipAction"
      type="button"
      class="mh-style-picker__skip"
      :disabled="disabled || !!selectedAction"
      @click="$emit('action', skipAction)"
    >
      {{ skipLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'AIChatWidgetMobileHeroStylePicker',
  props: {
    header: {
      type: String,
      default: 'Mobile Hero',
    },
    cards: {
      type: Array,
      required: true,
    },
    skipAction: {
      type: String,
      default: '',
    },
    skipLabel: {
      type: String,
      default: 'Skip this image',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedAction: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.mh-style-picker {
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 16px;
  background: #f7f9fb;
  margin-top: 8px;
}

.mh-style-picker__header {
  font-size: 14px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1f2937;
}

.mh-style-picker__header-icon {
  color: #6b7280;
}

.mh-style-picker__cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.mh-style-picker__card {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover:not(:disabled) {
    border-color: #379C75;
  }

  &.is-selected {
    border-color: #379C75;
    background: #eaf7f2;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.mh-style-picker__card-thumb {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 8px;
  background: #f3f4f6;
}

.mh-style-picker__card-title {
  font-weight: 600;
  font-size: 13px;
  color: #1f2937;
}

.mh-style-picker__card-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.mh-style-picker__skip {
  margin-top: 12px;
  background: transparent;
  border: none;
  color: #379C75;
  font-size: 13px;
  cursor: pointer;
  padding: 0;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
